module.exports = __webpack_public_path__ + "static/media/building10.c7d6b7f6.svg";